import router, { openChildRoute } from "@/router";
import { constantRouterMap } from "@/router/basics.router";
import useGlobalEventBus from "@/hooks/useGlobalEventBus";
import { AppCollection, defaultTab, F2EHB_NAME } from "@/constant";
// import useActvieTab from "@/hooks/useActiveTab";
import { isEqual } from "lodash-es";
import store from "@/store";
import { getPathBeforeLastSlash } from "@/handles/router";
import { t } from '@/locales/i18n'

const EventBus = useGlobalEventBus();

const notifyClosePage = (tabItem: TabItem) => {
  // console.log(tabItem,'tabItemtabItem')
  EventBus.$registerMountedQueue(
    tabItem.app as AppCollection,
    "CLOSE_PAGE",
    { path: tabItem.childAppPath, app: tabItem.app, query: tabItem.query },
    store
  );
};

// tabs栏

export interface TabItem {
  app: AppCollection;
  childAppPath?: string;
  title: string;
  fullPath: string;
  path: string;
  name?: string;
  subName?: string;
  query?: any;
  params?: any;
}

export type TabState = {
  tabList: TabItem[];
};

// console.log(t,'tttttttttttttttttttt')

const state: TabState = {
  tabList: [defaultTab],
};

const tabs = {
  namespaced: true,

  state,

  mutations: {
    clearList(state: TabState) {
      state.tabList = [];
    },
    /**
     * @desc: 添加tab
     * @param { TabItem } item
     */
    setList(state: TabState, item: TabItem) {
      // console.log(item)
      const tabList = state.tabList;
      let result = true;
      // 防止固定路由
      for (let m = 0; m < constantRouterMap.length; m++) {
        if (constantRouterMap[m]["name"] === item.name) {
          result = false;
          break;
        }
      }
      // 防止重复添加
      for (let i = 0; i < tabList.length; i++) {
        // 分别解析tabList中的路由和当前添加的路由
        const exist = tabList[i].fullPath;
        const newly = item.fullPath;
        if (isEqual(exist, newly)) {
          result = false;
          if (!isEqual(tabList[i].query, item.query)) {
            //如果 当前页面tab 已经存在更新 query 参数
            tabList[i].query = item.query;
          }
          break;
        }
      }
      if (result) {
        // sessionStorage.setItem("CURRENT_CHILD_PATH", decodeURIComponent(item.fullPath));
        // sessionStorage.setItem("CURRENT_CHILD_TITLE", item.title);
        tabList.push(item);
      }
    },

    /**
     * @desc: 删除tab
     * @param { string } key tabkey
     */
    async delList(state: TabState, key: string) {
      const tabList = state.tabList;
      const route = router.currentRoute.value;
      // const [, setActiveKey] = useActvieTab();
      if (tabList.length <= 1) {
        openChildRoute(
          {
            path: "/control-center",
            name: defaultTab.title,
            appName: F2EHB_NAME,
            component: "null",
            key: "",
            children: [],
          },
          F2EHB_NAME,
          false,
          true,
          "tab"
        );
      }
      for (let i = 0; i < tabList.length; i++) {
        // console.log(tabList,'tabListtabList')
        const item = decodeURIComponent(tabList[i]["fullPath"]); // tab item
        const current = decodeURIComponent(route.fullPath); // 当前路由页
        let childPath = current;
        if (childPath.indexOf("?") >= 0) {
          // 只去掉第一个?后的内容，保留第一个?前和第一个?后的内容
          const firstQ = childPath.indexOf("?");
          const secondQ = childPath.indexOf("?", firstQ + 1);
          if (secondQ >= 0) {
            childPath = childPath.slice(0, secondQ);
          }
        }
        if (childPath.indexOf("&") >= 0) {
          childPath = childPath.split("&")[0];
        }
        if (item === key) {
          // 找到要删除的
          // console.log(childPath,key,'dddddddddddddddd')
          if (childPath === key) {
            // 要删除的是当前路由:
            //  - 1. 要删除的tab是最后一个tab，页面回退到左边的tab
            //  - 2. 要删除的tab不是最后一个tab，页面回退到右边的tab
            const tabItem =
              tabList.length - 1 === i ? tabList[i - 1] : tabList[i + 1];

            if (tabItem.params && Object.keys(tabItem.params)) {
              const path = getPathBeforeLastSlash(tabItem.childAppPath as string);

              // console.log(tabItem, path, "pathpathpath");
              openChildRoute(
                {
                  path: path,
                  name: tabItem.title || "",
                  appName: tabItem.app || F2EHB_NAME,
                  component: "null",
                  key: "",
                  children: [],
                  query: tabItem.query
                    ? Object.keys(tabItem.query).length
                      ? tabItem.query
                      : undefined
                    : undefined,
                  params: tabItem.params
                    ? Object.keys(tabItem.params).length
                      ? tabItem.params
                      : undefined
                    : undefined,
                },
                tabItem.app || F2EHB_NAME,
                false,
                true,
                "tab"
              );
            }

            if (!tabItem.params || !Object.keys(tabItem.params).length) {
              openChildRoute(
                {
                  path: tabItem.childAppPath as string,
                  name: tabItem.title || "",
                  appName: tabItem.app || F2EHB_NAME,
                  component: "null",
                  key: "",
                  children: [],
                  query: tabItem.query
                    ? Object.keys(tabItem.query).length
                      ? tabItem.query
                      : undefined
                    : undefined,
                },
                tabItem.app || F2EHB_NAME,
                false,
                true,
                "tab"
              );
            }
          }
          const itemTabList = tabList[i];
          //通知子应用关闭页面
          EventBus.$registerMountedQueue(
            itemTabList.app as AppCollection,
            "CLOSE_PAGE",
            { path: tabList[i]?.childAppPath, app: itemTabList.app,query: tabList[i]?.query },
            store
          );
          tabList.splice(i, 1); // 不是当前路由，直接删除
          break;
        }
      }
    },

    /**
     * @desc: 删除右侧
     * @param { number } index 选择tab序号
     */
    delRight(state: TabState, index: number) {
      const tabList = state.tabList;
      const route = router.currentRoute.value;
      let current = 0;

      if (tabList.length <= 1 || tabList.length - 1 === index) {
        return;
      }

      for (let i = 0; i < tabList.length; i++) {
        if (tabList[i]["fullPath"] === route.fullPath) {
          current = i;
          break;
        }
      }

      if (index < current) {
        const tabItem = tabList[index];
        if (tabItem.params && Object.keys(tabItem.params)) {
          const path = getPathBeforeLastSlash(tabItem.childAppPath as string);

          // console.log(tabItem, path, "pathpathpath");
          openChildRoute(
            {
              path: path,
              name: tabItem.title || "",
              appName: tabItem.app || F2EHB_NAME,
              component: "null",
              key: "",
              children: [],
              query: tabItem.query
                ? Object.keys(tabItem.query).length
                  ? tabItem.query
                  : undefined
                : undefined,
              params: tabItem.params
                ? Object.keys(tabItem.params).length
                  ? tabItem.params
                  : undefined
                : undefined,
            },
            tabItem.app || F2EHB_NAME,
            false,
            true,
            "tab"
          );
        }

        if (!tabItem.params || !Object.keys(tabItem.params).length) {
          openChildRoute(
            {
              path: tabItem.childAppPath as string,
              name: tabItem.title || "",
              appName: tabItem.app || F2EHB_NAME,
              component: "null",
              key: "",
              children: [],
              query: tabItem.query
                ? Object.keys(tabItem.query).length
                  ? tabItem.query
                  : undefined
                : undefined,
            },
            tabItem.app || F2EHB_NAME,
            false,
            true,
            "tab"
          );
        }
      }

      const removedTabs = tabList.slice(index + 1);
      removedTabs.forEach((item) => {
        if (item.fullPath !== defaultTab.fullPath) {
          notifyClosePage(item);
        }
      });
      state.tabList = tabList.slice(0, index + 1).concat(
        tabList.slice(index + 1).filter(item => item.fullPath === defaultTab.fullPath)
      );
    },

    /**
     * @desc: 删除左侧
     * @param { number } index 选择tab序号
     */
    delLeft(state: TabState, index: number) {
      const tabList = state.tabList;
      const route = router.currentRoute.value;
      let current = 0;

      if (tabList.length <= 1 || index === 0) {
        return;
      }

      for (let i = 0; i < tabList.length; i++) {
        if (tabList[i]["fullPath"] === route.fullPath) {
          current = i;
          break;
        }
      }

      if (index > current) {
        const tabItem = tabList[index];
        if (tabItem.params && Object.keys(tabItem.params)) {
          const path = getPathBeforeLastSlash(tabItem.childAppPath as string);

          // console.log(tabItem, path, "pathpathpath");
          openChildRoute(
            {
              path: path,
              name: tabItem.title || "",
              appName: tabItem.app || F2EHB_NAME,
              component: "null",
              key: "",
              children: [],
              query: tabItem.query
                ? Object.keys(tabItem.query).length
                  ? tabItem.query
                  : undefined
                : undefined,
              params: tabItem.params
                ? Object.keys(tabItem.params).length
                  ? tabItem.params
                  : undefined
                : undefined,
            },
            tabItem.app || F2EHB_NAME,
            false,
            true,
            "tab"
          );
        }

        if (!tabItem.params || !Object.keys(tabItem.params).length) {
          openChildRoute(
            {
              path: tabItem.childAppPath as string,
              name: tabItem.title || "",
              appName: tabItem.app || F2EHB_NAME,
              component: "null",
              key: "",
              children: [],
              query: tabItem.query
                ? Object.keys(tabItem.query).length
                  ? tabItem.query
                  : undefined
                : undefined,
            },
            tabItem.app || F2EHB_NAME,
            false,
            true,
            "tab"
          );
        }
      }

      // 通知将要删除的左侧 tab
      const removedTabs = tabList.slice(0, index);
      removedTabs.forEach(item => {
        if (item.fullPath !== defaultTab.fullPath) {
          notifyClosePage(item);
        }
      });
      state.tabList = tabList.slice(index);
      // 如果默认tab不存在则插入
      if (!state.tabList.some(tab => tab.fullPath === defaultTab.fullPath)) {
        state.tabList.unshift(defaultTab);
      }
    },

    /**
     * @desc: 删除其他
     * @param { number } index 选择tab序号
     */
    delOther(state: TabState, index: number) {
      const tabItem = state.tabList[index];
      if (tabItem.params && Object.keys(tabItem.params)) {
        const path = getPathBeforeLastSlash(tabItem.childAppPath as string);

        // console.log(tabItem, path, "pathpathpath");
        openChildRoute(
          {
            path: path,
            name: tabItem.title || "",
            appName: tabItem.app || F2EHB_NAME,
            component: "null",
            key: "",
            children: [],
            query: tabItem.query
              ? Object.keys(tabItem.query).length
                ? tabItem.query
                : undefined
              : undefined,
            params: tabItem.params
              ? Object.keys(tabItem.params).length
                ? tabItem.params
                : undefined
              : undefined,
          },
          tabItem.app || F2EHB_NAME,
          false,
          true,
          "tab"
        );
      }

      if (!tabItem.params || !Object.keys(tabItem.params).length) {
        openChildRoute(
          {
            path: tabItem.childAppPath as string,
            name: tabItem.title || "",
            appName: tabItem.app || F2EHB_NAME,
            component: "null",
            key: "",
            children: [],
            query: tabItem.query
              ? Object.keys(tabItem.query).length
                ? tabItem.query
                : undefined
              : undefined,
          },
          tabItem.app || F2EHB_NAME,
          false,
          true,
          "tab"
        );
      }

      state.tabList.forEach(item => {
        if (item.fullPath !== tabItem.fullPath && item.fullPath !== defaultTab.fullPath) {
          notifyClosePage(item);
        }
      });
      state.tabList = [tabItem, defaultTab];
      // 若 defaultTab 不在列表中，则加入
      if (!state.tabList.find(tab => tab.fullPath === defaultTab.fullPath)) {
        state.tabList.unshift(defaultTab);
      }
    },

    openPage(state: TabState, key: string) {
      const tabList = state.tabList;
      const item = tabList.find(v => v.fullPath === key)
      const localitonInfo = window.location
      window.open(localitonInfo.origin + localitonInfo.pathname + '#' + item?.path)
    },

    /**
     * @desc: 按 fullPath 精确匹配 tab 并更新 subName
     * @param { string } fullPath tab 的 fullPath
     * @param { string } subName 新的副标题
     */
    setSubName(
      state: TabState,
      { fullPath, childAppPath, subName }: { fullPath: string; childAppPath: string; subName: string }
    ) {
      const target = decodeURIComponent(fullPath);
      const tab = state.tabList.find(
        (t) => decodeURIComponent(t.fullPath) === target || t.childAppPath === childAppPath
      );
      if (tab) tab.subName = subName;
    },
  },
};

export default tabs;
